var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lines)?_c('v-timeline',{attrs:{"dense":""}},_vm._l((_vm.lines),function(line){return _c('TimelineItem',{key:line.timestamp,attrs:{"line":line}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }